import React from 'react'

export const HardwareSelectorFilterSidebarContext = React.createContext<{ location: 'shop' | 'design' }>({
  location: 'design',
})
